import Immutable from 'immutable';

const UnitQuizResultRecord = Immutable.Record({
  unitId: undefined,
  totalScore: undefined,
  skillResults: undefined,
});

class UnitQuizResult extends UnitQuizResultRecord { }

export default UnitQuizResult;



// WEBPACK FOOTER //
// ./data/UnitQuiz/model/UnitQuizResult/model.js